import React from "react";

const eur = (v) => `${(Number(v) || 0).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

export const computeMargin = (sale, purchase) => {
    const s = Number(sale) || 0;
    const p = Number(purchase) || 0;
    return { sale: s, purchase: p, margin: s - p, rate: s ? ((s - p) / s) * 100 : 0 };
};

export default function MarginSummary({ sale, purchase, testid = "margin-summary" }) {
    const m = computeMargin(sale, purchase);
    const noPurchase = !m.purchase;
    const color = noPurchase ? "text-amber-600" : m.margin < 0 ? "text-red-600" : "text-emerald-700";
    const rate = m.rate.toLocaleString("fr-FR", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    return (
        <div className="grid grid-cols-3 gap-3 rounded-xl bg-slate-50 border border-slate-200 p-3" data-testid={testid}>
            <Cell label="Achat HT" value={eur(m.purchase)} testid={`${testid}-purchase`} />
            <Cell label="Vente HT" value={eur(m.sale)} testid={`${testid}-sale`} />
            <Cell label="Marge" value={noPurchase ? "—" : eur(m.margin)} sub={noPurchase ? "Prix d'achat non renseigné" : m.sale ? `${rate} %` : "—"} cls={color} testid={`${testid}-margin`} />
        </div>
    );
}

function Cell({ label, value, sub, cls = "", testid }) {
    return (
        <div>
            <div className="text-[11px] uppercase tracking-wider text-slate-500">{label}</div>
            <div className={`font-mono font-semibold text-sm mt-0.5 ${cls}`} data-testid={testid}>{value}</div>
            {sub && <div className={`text-xs ${cls}`}>{sub}</div>}
        </div>
    );
}
